import { axiosWdw, domainEndpoint } from './axios';

const endpoint = '/project';

export default {
  get() {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint,
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  getItem(id: number, fieldset = 'default') {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint + '/' + id,
      params: { fieldset: fieldset },
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  getTopicAtGeoposition(id: number, lon: number, lat: number, fieldset = 'default') {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint + '/' + id + '/topic/at_geoposition',
      params: {
        lon: lon,
        lat: lat,
        fieldset: fieldset,
      },
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  getTopicsAtGeoposition(id: number, lon: number, lat: number, fieldset = 'default') {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint + '/' + id + '/topic/at_geoposition',
      params: {
        lon: lon,
        lat: lat,
        fieldset: fieldset,
        all_topics: true,
      },
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  getAttributeStats(projectid: number, attributeid: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + '/' + projectid + '/stats_by_attribute',
        params: { attributeid: attributeid },
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
